import { render, staticRenderFns } from "./NewChannel.vue?vue&type=template&id=64a354be&scoped=true&"
import script from "./NewChannel.vue?vue&type=script&lang=js&"
export * from "./NewChannel.vue?vue&type=script&lang=js&"
import style0 from "./NewChannel.vue?vue&type=style&index=0&id=64a354be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a354be",
  null
  
)

export default component.exports